/**
 * 融媒号拖动排序  by xcc
 */
import React from 'react';
import {message, Modal, Spin} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import RmSortTable from "./RmSortTable";

export default class RmSort extends BaseComponent {
    static propTypes = {};
    static defaultProps = {
        title: "拖动排序",
        orderField: "sort"
    };

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            spinning: false,
            selectedKeys:""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    showSortModal = (selectedKeys) => {
        this.setState({
            visible: true,
            selectedKeys
        });
    };

    handleOk = () => {
        this.setState({
            spinning: true
        });
        let that = this;
        let sortIds = [];
        let sortFields = [];
        let newSortList = this.RmSortTable.state.sortList;
        newSortList.forEach((item, index) => {
            sortIds.push(item.id);
            sortFields.push(item.sort);
        });
        let isCheckedRootNode = ["","0-0"].indexOf(this.state.selectedKeys[0]) > -1;//是否选中了根节点
        let params = {
            ids: sortIds.toString(),
            sorts: sortFields.toString(),
            groupId:isCheckedRootNode?"all":this.state.selectedKeys
        };
        this.request({
            url: "/cm-sites-mmp/rm/updateSort",
            body: params,
            method: "get",
            contentType: "json",
            callBack: (res) => {
                message.success("排序成功", 2, function () {
                    that.setState({
                        visible: false,
                        spinning: false
                    })
                    that.props.refreshList();
                });
            }
        });
    }

    handleCancel = () => {
        this.setState({
            visible: false
        });
    };

    render() {
        let {title, orderField, rmGroupId} = this.props;
        let {visible} = this.state;
        return (
            <Modal
                title={title}
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                destroyOnClose={true}
                width={"65%"}
            >
                <Spin spinning={this.state.spinning}>
                    <RmSortTable orderField={orderField} rmGroupId={rmGroupId} ref={(RmSortTable) => this.RmSortTable = RmSortTable}/>
                </Spin>
            </Modal>
        )
    }
}